module.exports = __webpack_public_path__ + "img/shipo-map-vessel-1.5107fc20.svg";